/**
 * Twin Fonts, the capture-the-flag map (docs/spellweave-modes.md §2): 64 x 32,
 * mirrored left to right. Each base has its flag on a plinth by the back
 * wall, a shallow font to steam with, two pillars and a wall of cover out
 * in the field. A river runs down the middle, deep but for one stone bridge:
 * cold freezes the water into extra bridges for a while (the Flooded Hall's
 * ice), so a team can flank round the bridge.
 *
 * Tiles: '#' wall, '.' floor, '~' shallow water, '=' deep water (level.ts).
 */

import type { LevelDef } from './level.js';
import { PLAYER_SPAWN_RING } from './constants.js';

export const FONTS_LEVEL: LevelDef = {
  format: 1,
  id: 'fonts',
  name: 'Twin Fonts',
  w: 64,
  h: 32,
  tiles: {
    rows: [
      '################################################################',
      '####.........................~====~.........................####',
      '####.........................~====~.........................####',
      '####.........................~====~.........................####',
      '#...~~~~~~...................~====~...................~~~~~~...#',
      '#...~~~~~~........##.........~====~.........##........~~~~~~...#',
      '#...~~~~~~........##.........~====~.........##........~~~~~~...#',
      '#...~~~~~~........##.........~====~.........##........~~~~~~...#',
      '#.................##.........~====~.........##.................#',
      '#.................##.........~====~.........##.................#',
      '#............................~====~............................#',
      '#............................~====~............................#',
      '#............................~====~............................#',
      '#............................~====~............................#',
      '#..............................................................#',
      '#..............................................................#',
      '#..............................................................#',
      '#..............................................................#',
      '#............................~====~............................#',
      '#............................~====~............................#',
      '#............................~====~............................#',
      '#............................~====~............................#',
      '#.................##.........~====~.........##.................#',
      '#.................##.........~====~.........##.................#',
      '#.................##.........~====~.........##.................#',
      '#.................##.........~====~.........##.................#',
      '#.................##.........~====~.........##.................#',
      '#............................~====~............................#',
      '####.........................~====~.........................####',
      '####.........................~====~.........................####',
      '####.........................~====~.........................####',
      '################################################################',
    ],
  },
  solids: [
    { shape: { k: 'circle', x: 13, y: 11, r: 0.8 }, art: 'pillar' },
    { shape: { k: 'circle', x: 13, y: 21, r: 0.8 }, art: 'pillar' },
    { shape: { k: 'circle', x: 51, y: 11, r: 0.8 }, art: 'pillar' },
    { shape: { k: 'circle', x: 51, y: 21, r: 0.8 }, art: 'pillar' },
  ],
  water: [],
  rooms: [{ id: 'field', rect: { x: 0, y: 0, w: 64, h: 32 } }],
  doors: [],
  // the map's middle (no enemies come out on a PvP map; the format wants one)
  spawn: { x: 32, y: 16, ring: PLAYER_SPAWN_RING },
  gates: [{ x: 32, y: 16 }],
  dummies: [],
  teams: [
    { name: 'Rose', spawn: { x: 10, y: 16, ring: PLAYER_SPAWN_RING }, flag: { x: 5, y: 16 } },
    { name: 'Lime', spawn: { x: 54, y: 16, ring: PLAYER_SPAWN_RING }, flag: { x: 59, y: 16 } },
  ],
  art: { plate: 'fonts' },
};
